enum ReferencingStatus {
  MISSING = "missing",
  // PARTIAL = "partial", // BL-924
  TOTAL = "total",
}

export default ReferencingStatus;
